import watchMaritalStatusOptions from './maritalStatusOptions'

export default watchMaritalStatusOptions
